import Vue from 'vue'
import Element from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import VueClipboard from 'vue-clipboard2'

import './element-variables.scss'
import locale from 'element-ui/lib/locale/lang/ru-RU'

Vue.use(VueClipboard)
Vue.use(VueApexCharts)
Vue.use(Element, { locale })
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
